// extracted by mini-css-extract-plugin
export default {"review":"ProductReview_review__yGeMP","infoReview":"ProductReview_infoReview__C29C7","paymentReview":"ProductReview_paymentReview__KHolI"};